import { LOGOUT, SET_SESSION } from "./actionTypes";
import { Session } from "../type";

export function setSession(session: Session) {
    return {
        type: SET_SESSION,
        payload: session
    }
}

export function logout() {
    return {
        type: LOGOUT
    }
}